import {useUnit} from 'effector-react';
import {useEffect} from 'react';
import {$homeStore, fetchDashboardRequested} from '../store';

export const useHomeViewModel = () => {
  const [homeState, fetchDashboard] = useUnit([$homeStore, fetchDashboardRequested]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    dashboard: homeState.dashboard,
    loading: homeState.loading,
    error: homeState.error,
    refetch: fetchDashboard,
  };
};